import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = {
  registerAuthor: async (userData) => {
    const response = await axios.post(`${API}/auth/register`, userData);
    return response.data;
  },

  loginAuthor: async (credentials) => {
    const response = await axios.post(`${API}/auth/login`, credentials);
    return response.data;
  },

  getCurrentUser: async (userId) => {
    const response = await axios.get(`${API}/auth/me?user_id=${userId}`);
    return response.data;
  },
};
